export default __webpack_public_path__ + "static/media/twitter.5ae9f4cf.svg";